import React from "react";
export const Language = (props) => {
	return (
		<label className="switch">
			<input
				type="checkbox"
				onClick={() => {
					props.toggleLanguage();
				}}
			/>
			<span className="slider round"></span>
		</label>
	);
};



// WEBPACK FOOTER //
// ./src/components/Language.js